import Jobs from "../components/Jobs";
import UserLayout from "../components/UserLayout";

const JobPage = () => {
    return (
        <UserLayout>
            <Jobs />
        </UserLayout>
    );
}

export default JobPage;